import CloseIcon from '@eduzz/houston-icons/Cancel';
import Typography from '@eduzz/houston-ui/Typography';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import clsx from 'clsx';
import { WithStyles } from 'decorators/withStyles';
import React from 'react';

import { AlertGlobalProvider } from './global';
import styles from './styles';

interface IState {
  opened: boolean;
  message?: React.ReactNode;
  title?: React.ReactNode;
  confirmation?: boolean;
  buttonOk?: React.ReactNode;
  buttonCancel?: React.ReactNode;
}

interface IProps {
  opened: boolean;
  message: React.ReactNode;
  title?: React.ReactNode;
  buttonOk?: React.ReactNode;
  buttonCancel?: React.ReactNode;
  confirmation?: boolean;
  global?: boolean;
  onClose: (ok: boolean) => void;
  classes?: any;
  noPadding?: boolean;
  showTitle?: boolean;
  small?: boolean;
}

export interface IAlertShowParams {
  message?: React.ReactNode | string;
  title?: React.ReactNode;
  confirmation?: boolean;
  small?: boolean;
  buttonOk?: React.ReactNode;
  buttonCancel?: React.ReactNode;
}

@WithStyles(styles)
class Alert extends React.Component<IProps, IState> {
  static getDerivedStateFromProps(nextProps: IProps, prevState: IState): IState {
    if (!nextProps.opened) {
      return { ...prevState, opened: false };
    }

    return nextProps;
  }

  static show(params: string): Promise<boolean>;
  static show(params: IAlertShowParams): Promise<boolean>;
  static show(params: string | IAlertShowParams) {
    const paramsData = typeof params === 'string' ? { message: params } : params;
    return AlertGlobalProvider.show({ ...paramsData, small: paramsData.small || false });
  }

  static confirm(params: string): Promise<boolean>;
  static confirm(params: IAlertShowParams): Promise<boolean>;
  static confirm(params: string | IAlertShowParams) {
    const paramsData = typeof params === 'string' ? { message: params } : params;
    return AlertGlobalProvider.show({ ...paramsData, confirmation: true, small: paramsData.small || false });
  }
  static Global = AlertGlobalProvider;

  constructor(props: IProps) {
    super(props);
    this.state = { opened: false };
  }

  handleOk = () => {
    this.props.onClose(true);
  };

  handleCancel = () => {
    this.props.onClose(false);
  };

  render() {
    const { opened, title, message, confirmation, buttonCancel, buttonOk } = this.state;
    const { classes, noPadding, showTitle = true, small } = this.props;

    return (
      <Dialog id='alert-dialog' maxWidth={small ? 'xs' : 'sm'} open={opened} onClose={this.handleCancel} disableBackdropClick>
        {showTitle && (
          <DialogTitle id='alert-dialog-title' className={classes.titleContainer} disableTypography>
            <Typography className={classes.title} size='xs' weight='bold'>
              {title || (confirmation ? 'Confirmação' : 'Atenção')}

              <IconButton id='alert-close-icon-button' size='small' onClick={this.handleCancel}>
                <CloseIcon size={24} />
              </IconButton>
            </Typography>
          </DialogTitle>
        )}

        <DialogContent
          id='alert-dialog-content'
          className={clsx(classes.content, noPadding && classes.noPadding)}
          classes={{ root: noPadding ? classes.root : null }}
          dividers
        >
          {typeof message === 'string' ? <Typography>{message}</Typography> : message}
        </DialogContent>

        <DialogActions className={classes.actions}>
          {confirmation && (
            <Button id='alert-cancel-button' onClick={this.handleCancel} variant='text'>
              {buttonCancel || 'Cancelar'}
            </Button>
          )}
          <Button id='alert-confirm-button' variant='contained' color='primary' onClick={this.handleOk}>
            {buttonOk || 'Confirmar'}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default Alert;
